(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
    key: "AIzaSyCWtdH_aDfa6XtRBZwF8rV9KIUz2_8CEFE",
});


let center;
if (($('.stores #map')).length) {
    center = { lat: parseFloat(citymap[0].lat_long.split(', ')[0]), lng: parseFloat(citymap[0].lat_long.split(', ')[1]) };
}

let mapCenter = center;
let map;
let map_mobile;

let counterMap = 0;
let page = 0;

let filter_country = 'All';
let filter_input = '';

let markersD = {};
let markersM = {};

let currentInfoWindow_D = null;
let currentInfoWindow_M = null;

$(document).ready(function() {

    $('.paginate.custom').each(function() {
        initializePagination($(this));
    });

    let headerH = $('.header').height();
    $('.stores .map-wrapper').css('height', `calc(100% - ${headerH}px)`);
        
    if ($('.stores #map').length) {
    if (Object.keys(citymap).length > 0) {
        for (const city in citymap) {
        counterMap++;
        page = Math.floor((counterMap - 1) / 5) + 1;

        const latLng = citymap[city].lat_long.split(',');
        const lat = parseFloat(latLng[0]);
        const lng = parseFloat(latLng[1]);

        let append = `
            <div class="location" 
            data-page="${page}" 
            data-lat="${lat}" 
            data-lng="${lng}" 
            data-country="${citymap[city].country}" 
            data-type="${citymap[city].type}" 
            data-address="${citymap[city].address}" 
            data-contact="${citymap[city].contact}" 
            data-title="${citymap[city].title}">
            <p class="location-name">${citymap[city].title}</p>
            <p class="location-details">
                <img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016">
                <span><span>Address:</span> ${citymap[city].address}</span>
            </p>
            <p class="location-details">
                <img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017">
                <span><span>Contact:</span> ${citymap[city].contact}</span>
            </p>
            </div>
        `;

        $('.locations').append(append);
        }

        locPaginate();
    }

    async function initMap() {
        const { Map } = await google.maps.importLibrary("maps");

        const mapEl = document.getElementById("map");
        const mapMobileEl = document.getElementById("map-mobile");

        if (!mapEl) return;

        map = new Map(mapEl, {
        center: mapCenter,
        zoom: 4,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
        });

        if (mapMobileEl) {
        map_mobile = new Map(mapMobileEl, {
            center: mapCenter,
            zoom: 4,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false
        });
        }

        for (const city in citymap) {
        const latLng = citymap[city].lat_long.split(',');
        const center = {
            lat: parseFloat(latLng[0]),
            lng: parseFloat(latLng[1])
        };

        const markerD = new google.maps.Marker({
            position: center,
            map: map
        });

        if (map_mobile) {
            new google.maps.Marker({
            position: center,
            map: map_mobile
            });
        }

        const contentString = `
            <div class="map-info">
            <div class="map-more">
                <p class="body fw-medium f-black">${citymap[city].title}</p>
                <p class="map-details">
                <img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016">
                <span><b>Address:&nbsp;</b> ${citymap[city].address}</span>
                </p>
                <p class="map-details">
                <img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017">
                <span><b>Contact:&nbsp;</b> ${citymap[city].contact}</span>
                </p>
            </div>
            </div>
        `;

        markerD.infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        markerD.addListener("click", () => {
            if (currentInfoWindow_D) {
            currentInfoWindow_D.close();
            }

            markerD.infowindow.open(map, markerD);
            currentInfoWindow_D = markerD.infowindow;
        });

        markersD[`${center.lat},${center.lng}`] = markerD;
        }
    }

    initMap();
    }

    contact_details();
    contact_form();
});

$(window).resize(function() {
    let headerH = $('.header').height();
    $('.stores .map-wrapper').css('height', `calc(100% - ${headerH}px)`);
});

$(window).scroll(function() {
    contact_details();
    contact_form();
});

$(document).on('click', '.location', function() {;
    const lat = $(this).data('lat');
    const lng = $(this).data('lng');
    const markerKey = `${lat},${lng}`;

    map.setZoom(15);
    map.panTo({ lat, lng });
    map_mobile.setZoom(15);
    map_mobile.panTo({ lat, lng });

    if (markersD[markerKey]) {
        google.maps.event.trigger(markersD[markerKey], 'click');
    }
});

$('.map-wrapper .map-header').on('click', function() {
    $('.map-wrapper').hide();
    $('body').css('overflow-y', 'visible');
});

$('select[name="retail-country"]').on('change', function() {
    filter_country = $(this).val();

    filterLocation(filter_country, filter_input);
});
$('.filter-input .search-btn').on('click', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})
$('.filter-input input').on('keyup', function() {
    filter_input = $('input[name="search-address"]').val();

    filterLocation(filter_country, filter_input);
})

function filterLocation(country, location) {

    let show = citymap;

    if (country.toLowerCase() !== 'all') {
        show = show.filter(x => 
            x.country.toLowerCase().indexOf(country.toLowerCase()) >= 0
        );
    }
    if (location.toLowerCase() !== '') {
        show = show.filter(x => 
            x.address.toLowerCase().indexOf(location.toLowerCase()) >= 0 || 
            x.title.toLowerCase().indexOf(location.toLowerCase()) >= 0
        );
    }

    if (show.length > 0) {
        $('.locations').html('');
        counterMap = 0;
        
        for (let city in show) {
            counterMap ++;
            page = Math.floor((counterMap - 1) / 5) + 1;
            let append = '<div class="location" data-page="'+page+'" data-lat="'+parseFloat(show[city].lat_long.split(', ')[0])+'" data-lng="'+parseFloat(show[city].lat_long.split(', ')[1])+'" data-country="'+show[city].country+'" data-type="'+show[city].type+'" data-address="'+show[city].address+'" data-contact="'+show[city].contact+'" data-title="'+show[city].title+'">'+
                                '<p class="location-name">'+show[city].title+'</p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/location.png?v=1730186016"><span><span>Address:</span> '+show[city].address+'</span></p>'+
                                '<p class="location-details"><img src="https://cdn.shopify.com/s/files/1/0639/3492/2809/files/call.png?v=1730186017"><span><span>Contact:</span> '+show[city].contact+'</span></p>'+
                            '</div>';

            $('.locations').append(append);
        }

        locPaginate();

        map.setZoom(15);
        map.panTo({
            lat : parseFloat(show[0].lat_long.split(', ')[0]),
            lng : parseFloat(show[0].lat_long.split(', ')[1])
        });
    }
    else {
        $('.locations').html('<div class="no-found">No store found.</div>');
    }
}

function locPaginate() {
    if (window.innerWidth < 1250) {
        if (counterMap > 1) {
            const itemsPerPage = 1;
            const totalItems = counterMap;
            const totalPages = Math.floor(totalItems / itemsPerPage);
            const remainder = totalItems % itemsPerPage;
    
            let pageTotal = totalPages;
            if (remainder !== 0) {
                pageTotal += 1;
            }
    
            const $pagination = $('<div class="paginate custom d-lg-none d-md-flex d-sm-flex" data-total="' + pageTotal + '"></div>');
    
            const $leftArrow = $('<a class="page disable" href="javascript:void(0)"><i class="fa-solid fa-chevron-left"></i></a>');
            $pagination.append($leftArrow);
    
            for (let i = 1; i <= pageTotal; i++) {
                const $pageLink = $('<a class="page' + (i === 1 ? ' active' : '') + '" href="javascript:void(0)" data-i="' + i + '">' + i + '</a>');
                $pagination.append($pageLink);
            }
    
            const $rightArrow = $('<a class="page" href="javascript:void(0)" data-i="' + (pageTotal) + '"><i class="fa-solid fa-chevron-right"></i></a>');
            $pagination.append($rightArrow);
    
            $('.stores .locations').append($pagination);
            initializePagination($($pagination));
        }
    }
}

function updatePagination($pagination, currentPage, totalPages) {

    $pagination.empty();

    $pagination.append(`
        <a class="page ${currentPage === 1 ? 'disable' : ''}" href="javascript:void(0)" data-action="prev">
            <i class="fa-solid fa-chevron-left"></i>
        </a>
    `);

    let pageNumbers = '';

    if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }
    } else {
        const maxPagesToShow = 2;
        const startPage = Math.max(2, currentPage - maxPagesToShow);
        const endPage = Math.min(totalPages - 1, currentPage + maxPagesToShow);

        pageNumbers += `<a class="page ${currentPage === 1 ? 'active' : ''}" href="javascript:void(0)" data-i="1">1</a>`;

        if (startPage > 2) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers += `<a class="page ${i === currentPage ? 'active' : ''}" href="javascript:void(0)" data-i="${i}">${i}</a>`;
        }

        if (endPage < totalPages - 1) {
            pageNumbers += '<a class="page disable" href="javascript:void(0)">…</a>';
        }

        pageNumbers += `<a class="page ${currentPage === totalPages ? 'active' : ''}" href="javascript:void(0)" data-i="${totalPages}">${totalPages}</a>`;
    }

    $pagination.append(pageNumbers);

    $pagination.append(`
        <a class="page ${currentPage === totalPages ? 'disable' : ''}" href="javascript:void(0)" data-action="next">
            <i class="fa-solid fa-chevron-right"></i>
        </a>
    `);

    const $customRow = $pagination.parent();
    $customRow.find('[data-page]').hide();
    $customRow.find(`[data-page="${currentPage}"]`).show();
}

function initializePagination($pagination) {
    const totalPages = $pagination.data('total');
    let currentPage = 1;

    updatePagination($pagination, currentPage, totalPages);

    $pagination.on('click', '.page[data-i]', function() {
        const newPage = $(this).data('i');
        if (newPage && newPage !== currentPage) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage = newPage;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="prev"]', function() {
        if (currentPage > 1) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage--;
            updatePagination($pagination, currentPage, totalPages);
        }
    });

    $pagination.on('click', '[data-action="next"]', function() {
        if (currentPage < totalPages) {

            $('html, body').animate({
                scrollTop: $pagination.closest('.row').offset().top - 400
            }, 0);

            currentPage++;
            updatePagination($pagination, currentPage, totalPages);
        }
    });
}

function contact_details() {
    if ($('.contact-details').length) {
        $('.contact-details').each(function() {
            let el = $(this);

            if (visiblePercent(el) > 50) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}

function contact_form() {
    if ($('.contact-form').length) {
        $('.contact-form').each(function() {
            let el = $(this);

            let scrolled = sectionPercent(el) * 2;

            if (scrolled > 150) {
                el.find('.sticky').addClass('active');
                el.find('.floating-text').addClass('active');
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.sticky').removeClass('active');
                el.find('.floating-text').removeClass('active');
                el.find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}

$('.contact-form .contact-us').on('click', function() {
    let el = $(this).parents('.contact-form');
    el.find('.popup-form').fadeIn();
    el.find('.popup-form .wrapper').css('right', '0');

    $('html').css('overflow', 'hidden');
});

$('.contact-form .popup-form .overlay, .contact-form .popup-form .form-close').on('click', function() {
    let el = $(this).parents('.popup-form');
    el.fadeOut();
    el.find('.wrapper').css('right', '-100%');

    $('html').css('overflow', 'auto');
});

$(document).on('change', '.contact-form .form-check-input[type="checkbox"]', function() {
    let parent = $(this).parents('[data-check]').data('check');
    const $group = $(this).closest(`[data-check="${parent}"]`);
    const $checkOther = $group.find('.check-other');
    
    const isOther = $(this).val() === 'Other';

    $group.find('.form-check-input').each(function () {
        const $input = $(this);
        const isInputOther = $input.val() === 'Other';

        if (isOther && !isInputOther) {
            $input.prop('checked', false);
        }

        if (!isOther && isInputOther) {
            $input.prop('checked', false)
                .closest('[data-check]')
                .find('.check-other')
                .val('')
                .attr('readonly', true);
        }
    });

    if (isOther) {
        if ($(this).prop('checked')) {
            $checkOther.attr('readonly', false);
        } else {
            $checkOther.val('').attr('readonly', true);
        }
    }

    const checkedValues = $group.find('.form-check-input')
        .filter((_, el) => el.checked)
        .map((_, el) => el.value)
        .get();

    if (parent === 'checkbox-1') {
        $('#get_in_touch [name="contact[land_type]"]').val(checkedValues.length ? checkedValues.join(', ') : 'N/A');
    } 
    else if (parent === 'checkbox-2') {
        $('#get_in_touch [name="contact[intended_use]"]').val(checkedValues.length ? checkedValues.join(', ') : 'N/A');
    }
    else if (parent === 'checkbox-3') {
        $('#get_in_touch [name="contact[key_features]"]').val(checkedValues.length ? checkedValues.join(', ') : 'N/A');
    }
});

$('.contact-form .check-other').on('keyup', function() {
    let parent = $(this).parents('[data-check]').data('check');

    if (parent == 'checkbox-1') {
        $('#get_in_touch [name="contact[land_type]"]').val('Other: ' + $(this).val());
    }
    else if (parent == 'checkbox-2') {
        $('#get_in_touch [name="contact[intended_use]"]').val('Other: ' + $(this).val());
    }
    else if (parent == 'checkbox-3') {
        $('#get_in_touch [name="contact[key_features]"]').val('Other: ' + $(this).val());
    }
    else if (parent == 'radio-1') {
        $('#get_in_touch [name="contact[land_permits]"]').val('Yes: ' + $(this).val());
    }
    if (parent == 'radio-3') {
        $('#get_in_touch [name="contact[preferred_floor_plan]"]').val('Other: ' + $(this).val());
    }
    if (parent == 'radio-5') {
        $('#get_in_touch [name="contact[customized_design]"]').val('Yes: ' + $(this).val());
    }
});

$(document).on('change', '.contact-form .form-check-input[type="radio"]', function() {
    let parent = $(this).parents('[data-check]').data('check');

    if (parent === 'radio-1') {
        $('#get_in_touch [name="contact[land_permits]"]').val($(this).val());
        if ($(this).val() === 'Yes') {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').attr('readonly', false);
        }
        else {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').val('').attr('readonly', true);
        }
    }
    else if (parent === 'radio-2') {
        $('#get_in_touch [name="contact[preferred_size_range]"]').val($(this).val());
    }
    else if (parent === 'radio-3') {
        $('#get_in_touch [name="contact[preferred_floor_plan]"]').val($(this).val());
        if ($(this).val() === 'Other') {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').attr('readonly', false);
        }
        else {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').val('').attr('readonly', true);
        }
    }
    else if (parent === 'radio-4') {
        $('#get_in_touch [name="contact[estimated_budget]"]').val($(this).val());
    }
    else if (parent === 'radio-5') {
        $('#get_in_touch [name="contact[customized_design]"]').val($(this).val());
        if ($(this).val() === 'Yes') {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').attr('readonly', false);
        }
        else {
            $(this).parents(`[data-check="${parent}"]`).find('.check-other').val('').attr('readonly', true);
        }
    }
    else if (parent === 'radio-6') {
        $('#get_in_touch [name="contact[to_be_ready]"]').val($(this).val());
    }
});

$('.become-dealer .btn-dealer-form').on('click', function() {
    let el = $(this).parents('.become-dealer');
    el.find('.dealer-form').fadeIn();

    $('html').css('overflow', 'hidden');
});

$('.become-dealer .dealer-form .overlay, .become-dealer .dealer-form .form-close').on('click', function() {
    let el = $(this).parents('.dealer-form');
    el.fadeOut();

    $('html').css('overflow', 'auto');
});

$(document).on('change', '.dealer-form .form-check-input[type="checkbox"]', function() {
    let parent = $(this).parents('[data-check]').data('check');
    const $group = $(this).closest(`[data-check="${parent}"]`);
    const $checkOther = $group.find('.check-other');
    
    const isOther = $(this).val() === 'Other';

    $group.find('.form-check-input').each(function () {
        const $input = $(this);
        const isInputOther = $input.val() === 'Other';

        if (isOther && !isInputOther) {
            $input.prop('checked', false);
        }

        if (!isOther && isInputOther) {
            $input.prop('checked', false)
                .closest('[data-check]')
                .find('.check-other')
                .val('')
                .attr('readonly', true);
        }
    });

    if (isOther) {
        if ($(this).prop('checked')) {
            $checkOther.attr('readonly', false);
        } else {
            $checkOther.val('').attr('readonly', true);
        }
    }

    const checkedValues = $group.find('.form-check-input')
        .filter((_, el) => el.checked)
        .map((_, el) => el.value)
        .get();

    if (parent === 'checkbox-1') {
        $('#become_dealer_form [name="contact[industry_type]"]').val(checkedValues.length ? checkedValues.join(', ') : 'N/A');
    } 
    else if (parent === 'checkbox-2') {
        $('#become_dealer_form [name="contact[preferred_model]"]').val(checkedValues.length ? checkedValues.join(', ') : 'N/A');
    }
});

$('.become-dealer .check-other').on('keyup', function() {
    let parent = $(this).parents('[data-check]').data('check');

    if (parent == 'checkbox-1') {
        $('#become_dealer_form [name="contact[industry_type]"]').val('Other: ' + $(this).val());
    }
});


$(document).on('change', '.become-dealer .form-check-input[type="radio"]', function() {
    let parent = $(this).parents('[data-check]').data('check');

    if (parent === 'radio-1') {
        $('#become_dealer_form [name="contact[familiar_with_prefabricated]"]').val($(this).val());
    }

    if (parent === 'radio-2') {
        $('#become_dealer_form [name="contact[capability_for_installation]"]').val($(this).val());
    }
});